import { useState, useEffect } from 'react';
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

interface WalletDetails {
  legalEntity: string;
  accountNumber: string;
  accountName: string;
  currency: string;
  amount: number;
  walletId?: string;
  key: number;
}

export const useInvestmentWalletDetails = (
  customerId?: number | null,
  investmentProductDetailId?: number | null
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [wallets, setWallets] = useState<WalletDetails[]>([]);

  useEffect(() => {
    const fetchWalletDetails = async () => {
      // Always set loading to true when the dependencies change
      setLoading(true);
      setError(null);

      // Return early if we don't have both required parameters
      if (!customerId || !investmentProductDetailId) {
        // Keep loading true for a short period to show loading state
        setTimeout(() => setLoading(false), 500);
        return;
      }

      try {
        const response = await getDataWithDotNet(
          `${ajaxEndpoints.GET_CUSTOMER_WALLETS}?customerId=${customerId}&investmentProductDetailId=${investmentProductDetailId}`
        );

        if (response.data && response.data.wallets) {
          const formattedWallets = response.data.wallets.map((wallet: any, index: number) => ({
            key: index,
            legalEntity: wallet.legalEntity || '',
            accountNumber: wallet.accountNumber || '',
            accountName: wallet.accountName || '',
            currency: wallet.currency || '',
            amount: wallet.availableBalance || 0,
            walletId: wallet.walletId || '',
          }));

          setWallets(formattedWallets);
        } else {
          setWallets([]);
        }
      } catch (error) {
        console.error('Error fetching wallet details:', error);
        setError('Failed to fetch wallet details');
        setWallets([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWalletDetails();
  }, [customerId, investmentProductDetailId]);

  return {
    loading,
    error,
    wallets
  };
};
